import { all } from 'redux-saga/effects';
import { watchReadNotification } from '../components/Header/saga/ReadNotificationSaga.js';
import { watchForgotPassword } from '../modules/authentication/ForgotPassword/saga/ForgotPasswordSaga.js';
import { watchLogin } from '../modules/authentication/Login/saga/ValidateLoginUserSaga.js';
import { watchNewPassword } from '../modules/authentication/NewPassword/saga/NewPasswordSaga.js';
import { watchFileRejct } from '../modules/authorization/Dashboard/saga/FileRejectSaga.js';
import { watchProofreaderDashboard } from '../modules/authorization/Dashboard/saga/GetProofreaderDashboardSaga.js';
import { watchCheckForceUnclaim } from '../modules/authorization/Editor/saga/CheckForceUnclaimSaga.js';
import { watchEditorDocument } from '../modules/authorization/Editor/saga/EditorDocumentSaga.js';
import { watchEditor } from '../modules/authorization/Editor/saga/EditorSaga.js';
import { watchProofreaderRoleEditorSubmit } from '../modules/authorization/Editor/saga/ProofreaderRoleEditorSubmitSaga.js';
import { watchProofreaderUnClaim } from '../modules/authorization/Editor/saga/ProofreaderUnClaimSaga.js';
import {
  watchAddSpeaker,
  watchDeleteSpeaker,
  watchGetAllSpeaker,
  watchRemoveUnusedSpeaker,
  watchUpdateSpeaker,
} from '../modules/authorization/Editor/saga/SpeakerSaga.js';
import { watchVendorDetails } from '../modules/authorization/Editor/saga/VendorDetilsSaga.js';
import { watchVendorVendorNameList } from '../modules/authorization/Editor/saga/VendorNameListSaga.js';
import { watchVendorNextTrnascript } from '../modules/authorization/Editor/saga/VendorNextTranscriptSaga.js';
import { watchVendorResolveProofreader } from '../modules/authorization/Editor/saga/VendorProofreaderCommentSaga.js';
import { watchVendorProofreaderComment } from '../modules/authorization/Editor/saga/VendorResolveProofreaderSaga.js';
import { watchVendorSubmitFile } from '../modules/authorization/Editor/saga/VendorRoleEditorSubmitSaga.js';
import { watchProofreaderAllFilesList } from '../modules/authorization/Files/AllFiles/saga/GetProofreaderAllFilesListSaga.js';
import { watchProofreaderFilesFilterList } from '../modules/authorization/Files/AllFiles/saga/GetProofreaderFilesFilterListSaga.js';
import { watchProofreaderMyFilesList } from '../modules/authorization/Files/MyFiles/saga/GetProofreaderMyFilesListSaga.js';
import { watchMyMetrics } from '../modules/authorization/MyMetrics/saga/GetMyMetricsListSaga.js';
import { watchChangePassword } from '../modules/authorization/PersonalInformation/component/ChangePassword/saga/ChangePasswordSaga.js';
import { watchEditProfile } from '../modules/authorization/PersonalInformation/component/Profile/saga/EditProfileSaga.js';
import { watchGetProfile } from '../modules/authorization/PersonalInformation/component/Profile/saga/ProfileSaga.js';
import { watchGetStateList } from '../modules/authorization/PersonalInformation/component/Profile/saga/StateListSaga.js';
import { watchVendorsFilter } from '../modules/authorization/Vendors/saga/GetVendorsFilterListSaga.js';
import { watchVendors } from '../modules/authorization/Vendors/saga/GetVendorsListSaga.js';
import { watchFetchSlateData } from '../modules/authorization/Editor-Copy/saga/getSlateDataSaga.js';
import { watchRestore } from '../modules/authorization/Editor-Copy/saga/restoreSaga.js';
import { watchSaveSlateData } from '../modules/authorization/Editor-Copy/saga/saveSlateDataSaga.js';
import { watchVendorCompleteParagraph } from '../modules/authorization/Editor/saga/VendorCompleteParagraph.js';
import { watchFetchLegalTemplateFormFieldDetails } from '../modules/authorization/Editor-Copy/saga/getLegalTemplateFormFieldDetails.js';
import { watchSaveOrUpdateTemplateFormDetails } from '../modules/authorization/Editor-Copy/saga/saveOrUpdateTemplateFormDetails.js';
import { watchDownloadLegalDocument } from '../modules/authorization/Editor-Copy/saga/downloadLegalDocumentSaga.js';
import { watchUploadLegalDocument } from '../modules/authorization/Editor-Copy/saga/uploadLegalDocumentSaga.js';
import { watchCGAFilesList } from '../modules/authorization/Files/CGAFiles/saga/GetCGAFilesListSaga.js';
import { watchMergeCGAFileCollectionDownload } from '../modules/authorization/Files/CGAFiles/saga/MergeCGAFileCollectionDownloadSaga.js';
import { watchSaveFileMergeStatusCGA } from '../modules/authorization/Files/CGAFiles/saga/SaveFileMergeStatusCGASaga.js';
import { watchCGAClientList } from '../modules/authorization/Files/CGAFiles/saga/GetCGAClientListSaga.js';
import { watchGlossaryPreview, watchGlossaryList } from '../modules/authorization/Editor-Copy/saga/glossarySaga.js';

export default function* rootSaga() {
  yield all([
    watchLogin(),
    watchForgotPassword(),
    watchNewPassword(),
    watchReadNotification(),
    watchFileRejct(),
    watchMyMetrics(),
    watchGetProfile(),
    watchEditProfile(),
    watchGetStateList(),
    watchEditorDocument(),
    watchEditor(),
    watchCheckForceUnclaim(),
    watchProofreaderUnClaim(),
    watchVendors(),
    watchProofreaderDashboard(),
    watchProofreaderAllFilesList(),
    watchProofreaderMyFilesList(),
    watchProofreaderFilesFilterList(),
    watchVendorsFilter(),
    watchChangePassword(),
    watchVendorProofreaderComment(),
    watchVendorResolveProofreader(),
    watchVendorDetails(),
    watchVendorVendorNameList(),
    watchProofreaderRoleEditorSubmit(),
    watchVendorNextTrnascript(),
    watchGetAllSpeaker(),
    watchUpdateSpeaker(),
    watchDeleteSpeaker(),
    watchAddSpeaker(),
    watchRemoveUnusedSpeaker(),
    watchVendorSubmitFile(),
    watchFetchSlateData(),
    watchSaveSlateData(),
    watchRestore(),
    watchVendorCompleteParagraph(),
    watchFetchLegalTemplateFormFieldDetails(),
    watchSaveOrUpdateTemplateFormDetails(),
    watchDownloadLegalDocument(),
    watchUploadLegalDocument(),
    watchCGAFilesList(),
    watchMergeCGAFileCollectionDownload(),
    watchSaveFileMergeStatusCGA(),
    watchCGAClientList(),
    watchGlossaryPreview(),
    watchGlossaryList(),
  ]);
}
